import { AsyncForm, FormGroup } from '@components/async-form';
import { DialogFooter, DialogHeader, StandardDialog } from '@components/dialog';
import { showModalForm } from '@components/modal-form';
import { useState } from 'preact/hooks';

type Props = {
  initialName: string;
  onCancel(): void;
  onSubmit(name: string): Promise<void>;
};

function RenameDialog({ initialName, onCancel, onSubmit }: Props) {
  const [isSaving, setIsSaving] = useState(false);

  return (
    <StandardDialog onClose={onCancel}>
      <AsyncForm
        class="flex flex-col gap-4"
        onSubmit={async ({ name }: { name: string }) => {
          const trimmed = name.trim();
          if (!trimmed || trimmed === initialName) {
            onCancel();
            return;
          }
          setIsSaving(true);
          try {
            await onSubmit(trimmed);
          } finally {
            setIsSaving(false);
          }
        }}
      >
        <DialogHeader title="Rename file" />
        <FormGroup prop="name">
          <input
            type="text"
            name="name"
            class="ruz-input"
            defaultValue={initialName}
            autoFocus
            maxLength={255}
          />
        </FormGroup>
        <DialogFooter onClose={onCancel} isLoading={isSaving} confirmButtonText="Save" />
      </AsyncForm>
    </StandardDialog>
  );
}

export async function promptForRename(initialName: string): Promise<string | undefined> {
  return showModalForm<string | undefined>(({ resolve }) => (
    <RenameDialog
      initialName={initialName}
      onCancel={() => resolve(undefined)}
      onSubmit={async (name) => resolve(name)}
    />
  ));
}
